import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { dateReportFormatter } from "../../fomatters/DateFormatter";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function PlayerDeleted() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [dateOf, setDateOf] = useState(0);
  const onDateOfChange = useCallback(
    (event) => setDateOf(Number(event.target.value)),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [currency, setCurrency] = useState("");
  const onCurrencyChanged = useCallback((c) => setCurrency(c), []);
  const { values: currencies } = useDataFormatterHook({
    addEmpty: true,
    value: "currency",
    text: "currency",
    path: `/Agent/Currency_GetList`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          className="flex-1"
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />

        <div>
          <SubGroup title="Group By">
            <FormControl component="fieldset">
              <RadioGroup label value={dateOf} onChange={onDateOfChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Deleted"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Opened"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Last Wager"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Currency"
          name="name"
          data={currencies}
          placeholder="DataFormatter"
          setSelectValue={onCurrencyChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <Report
        title="Players Deleted Report"
        getUrl={() => "/Reports/Report_Players_Deleted_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          DateOf: dateOf,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          Currency: currency,
          Distributor: distributor,
        })}
      >
        {/* REAL COLUMNS */}
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="name">
          Name
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agent">
          Agent
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="accountOpened"
          dataFormat={dateReportFormatter}
        >
          Opened
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="lastWager"
          dataFormat={dateReportFormatter}
        >
          Last Wager
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="lastModification"
          dataFormat={dateReportFormatter}
        >
          Deleted
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="creditLimit"
          dataFormat={decimalInvertedReportFormatter}
        >
          Credit Limit
        </TableHeaderColumn>
        {/* PENDING */}
        <TableHeaderColumn dataSort dataField="currency">
          Currency
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default PlayerDeleted;
